import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'oa-workbench-summary',
  name: '办公概览',
  icon: '办',
  group: 'OA 组件',
  description: '展示待办、可发起流程和申请状态指标。',
  defaultProps: {
    title: '办公概览'
}
}
